import { useState } from "react";
import { Zap, Loader2, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api, { audioUrl } from "@/lib/api";

const KINDS = ["jump", "hit", "pickup", "victory", "defeat", "alert"];

export default function StingersRow({ theme, onChanged }) {
  const [sel, setSel] = useState(["jump", "hit", "victory"]);
  const [busy, setBusy] = useState(false);
  const have = theme.stingers || {};
  const toggle = (k) => setSel((s) => (s.includes(k) ? s.filter((x) => x !== k) : [...s, k]));
  const play = (path) => { const a = new Audio(audioUrl(path)); a.play().catch(() => toast.error("Playback blocked")); };
  const make = async () => {
    if (!sel.length) return;
    setBusy(true);
    try { await api.post(`/themes/${theme.id}/stingers`, { kinds: sel }); toast.success(`${sel.length} stinger(s) rendered in ${theme.key || "the theme key"}.`); onChanged?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Stinger render failed."); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-border bg-background/50 p-4 space-y-3" data-testid={`stingers-${theme.id}`}>
      <div className="flex items-center justify-between flex-wrap gap-2">
        <p className="text-sm font-semibold flex items-center gap-2"><Zap size={15} className="text-primary" /> Stingers <span className="text-xs text-muted-foreground font-normal">— one-shots in {theme.key || "the theme key"} · Surge XT · instant & free</span></p>
        <Button size="sm" className="h-8 gap-1.5 bg-primary text-primary-foreground hover:bg-primary/90" onClick={make} disabled={busy || !sel.length} data-testid={`stingers-make-${theme.id}`}>{busy ? <Loader2 size={13} className="animate-spin" /> : <Zap size={13} />} Render {sel.length}</Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {KINDS.map((k) => (
          <div key={k} className="flex items-center gap-1">
            <button type="button" onClick={() => toggle(k)} className={`px-3 py-1.5 rounded-full border text-xs capitalize transition-colors ${sel.includes(k) ? "border-primary text-primary bg-primary/10" : "border-border text-muted-foreground hover:text-foreground"}`} data-testid={`stinger-kind-${k}`}>{k}</button>
            {have[k] && <button type="button" onClick={() => play(have[k].path)} className="h-7 w-7 rounded-full border border-border grid place-items-center hover:bg-muted" title={`Play ${k} (${have[k].seconds}s)`} data-testid={`stinger-play-${theme.id}-${k}`}><Play size={11} /></button>}
          </div>
        ))}
      </div>
    </div>
  );
}
